import { Quasar, LocalStorage, Notify } from 'quasar'
import { getLanguage } from 'src/boot/i18n'
import { getCurrentPosition } from 'src/utils/utils'
import extraFlows from 'src/config/extraFlows'

const state = {
  language: getLanguage(),
  footer: {
    opened: !!+LocalStorage.getItem('footerStatus')
  },
  serverErrorMsg: null,
  geolocation: LocalStorage.getItem('geolocation') || null,
  targetSid: null,
  prevRouteName: null,
  extraFlow: null,
  oneTimeDealCode: null
}

const mutations = {
  SET_LANGUAGE (state, language) {
    state.language = language
    LocalStorage.set('language', language)

    // hook for EN only
    if (language === 'en') {
      language = 'en-us'
    }

    import(
      /* webpackInclude: /(nl|en-us)\.js$/ */
      'quasar/lang/' + language
    ).then(lang => {
      Quasar.lang.set(lang.default)
    })
  },
  TOGGLE_FOOTER (state, payload) {
    state.footer.opened = (payload !== undefined)
      ? !!payload
      : !state.footer.opened
    if (state.footer.opened) {
      LocalStorage.set('footerStatus', 1)
    } else {
      LocalStorage.set('footerStatus', 0)
    }
  },
  SET_SERVER_ERROR_MSG (state, msg = null) {
    state.serverErrorMsg = msg
  },
  SET_GEOLOCATION_COORDINATES (state, payload = null) {
    (payload)
      ? LocalStorage.set('geolocation', payload)
      : LocalStorage.remove('geolocation')
    state.geolocation = payload
  },
  SET_PREV_ROUTE_NAME (state, payload = null) {
    state.prevRouteName = payload
  },
  SET_EXTRA_FLOW (state, payload = null) {
    state.extraFlow = payload
  },
  SET_ONE_TIME_DEAL_CODE (state, payload = null) {
    state.oneTimeDealCode = payload
  }
}

const actions = {
  setLanguage ({ commit }, language) {
    commit('SET_LANGUAGE', language)
  },
  toggleFooter ({ commit }, payload) {
    commit('TOGGLE_FOOTER', payload)
  },
  setServerErrorMsg ({ commit }, payload) {
    commit('SET_SERVER_ERROR_MSG', payload)
  },
  setGeolocationCoordinates ({ commit }, payload) {
    commit('SET_GEOLOCATION_COORDINATES', payload)
  },
  mineGeolocationCoordinates ({ commit }, payload) {
    return getCurrentPosition({ maximumAge: 1000 * 60 * 10, timeout: 1000 * 10 })
      .then(
        (pos) => {
          let crd = pos.coords
          commit('SET_GEOLOCATION_COORDINATES', {
            lat: crd.latitude,
            long: crd.longitude
          })
          return pos
        },
        (err) => {
          Notify.create({
            color: 'negative',
            message: `Sorry, but the following error occurred: ${err.message}`,
            icon: 'report_problem',
            position: 'bottom',
            timeout: 4000
          })
          return err
        }
      )
  },
  setPrevRouteName ({ commit }, payload) {
    commit('SET_PREV_ROUTE_NAME', payload)
  },
  async setExtraFlow ({ commit }, payload = {}) {
    const { type: extraFlowName, activator } = payload
    let extraFlowConfig

    if (extraFlowName) {
      extraFlowConfig = extraFlows[extraFlowName]
    }

    if (activator) {
      extraFlowConfig = Object.values(extraFlows).find(o => {
        const { type, text } = o.activator
        if (activator.type === type && activator.text.includes(text)) {
          return true
        }
      })
    }
    commit('SET_EXTRA_FLOW', extraFlowConfig)
    return extraFlowConfig && { ...extraFlowConfig }
  },
  setOneTimeDealCode ({ commit }, payload = null) {
    commit('SET_ONE_TIME_DEAL_CODE', payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
